"use client"

import { useNavigate } from "react-router-dom";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent, TooltipArrow } from "@/components/ui/tooltip";
import { CalendarClock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useUserInfo } from "@/app/stores/useUserStore";

export default function CoReserve() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userInfo = useUserInfo();
  return (
    <div
      className="max-md:hidden transition-all flex items-center cursor-pointer gap-1 rounded-md bg-background-card border border-button-border/85 relative p-2 hover:border-button-border text-font-secondary hover:text-font-primary hover:bg-secondary-hover"
      role="button"
      tabIndex={0}
      onClick={() => navigate(`/${userInfo?.handle}/stream-reserve`)}
    >
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <CalendarClock className="w-4 h-4" />
          </TooltipTrigger>
          <TooltipContent className="TooltipContent" sideOffset={10} arrowPadding={10}>
            {t('header.myReservations')}
            <TooltipArrow className="TooltipArrow" />
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}
